import React from 'react';
import { Box, Typography, Button, Chip } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';

const DocumentHeader = ({ title, lastUpdated, effectiveDate, onPrint }) => {
  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
        <Typography variant="h3" component="h1" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          {title}
        </Typography>
        <Button
          variant="outlined"
          startIcon={<PrintIcon />}
          onClick={onPrint}
          className="print-hide"
          sx={{ ml: 2 }}
        >
          Print
        </Button>
      </Box>

      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
        <Chip 
          label={`Effective: ${effectiveDate}`} 
          color="primary" 
          variant="outlined" 
        />
        <Chip 
          label={`Updated: ${lastUpdated}`} 
          color="secondary" 
          variant="outlined" 
        />
      </Box>
    </Box>
  );
};

export default DocumentHeader;